import React, { useState } from 'react';
import { WarningFilled } from '@ant-design/icons';
import { Close } from '@material-ui/icons';

import {
  ENGAGEMENT_MOVED_MANAGE_BANNER_DISMISSED,
  isEngagementFlagSet,
  setEngagementFlag,
} from './flags';
import {
  Banner,
  IconWrapper,
  Text,
  CloseButton,
} from './ManageMigrationBanner.styled';

const BANNER_TEXT =
  "Engagement details now appear in each Contact's profile in the Manage screen.";

// Closeable warning banner announcing that engagement data moved into each
// Contact's profile. Hidden on mount if already dismissed; dismissing sets a
// global localStorage flag so it never returns in that browser.
const ManageMigrationBanner = () => {
  const [isVisible, setIsVisible] = useState(
    () => !isEngagementFlagSet(ENGAGEMENT_MOVED_MANAGE_BANNER_DISMISSED)
  );

  const handleClose = () => {
    setEngagementFlag(ENGAGEMENT_MOVED_MANAGE_BANNER_DISMISSED);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <Banner role="status">
      <IconWrapper>
        <WarningFilled />
      </IconWrapper>
      <Text>{BANNER_TEXT}</Text>
      <CloseButton
        type="button"
        aria-label="Dismiss engagement announcement"
        onClick={handleClose}
      >
        <Close fontSize="small" />
      </CloseButton>
    </Banner>
  );
};

export default ManageMigrationBanner;
